exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-ac563d0e]{padding:0}.footer_text[data-v-ac563d0e]{text-align:center;padding:15px 0}", ""]);

// exports
